import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/apiClient';

interface Application {
  id: number;
  slug: string;
  name_fa: string;
  name_en: string;
  download_count: number;
  download_count_text: string;
  totalPrice: number | string;
  logo: string | null;
  version: {
    major: number | null;
    minor: number | null;
    patch: number | null;
    build: number | null;
  };
  /** Derived from the `published` flag: PUBLISHED or UNPUBLISHED only. */
  status: string;
  /** 1 or 0 — the publisher's show/hide switch. */
  active: number;
  /** The review outcome, which `status` does not carry. */
  statuses?: {
    publish?: string | null;
    content?: string | null;
  };
}

// Fetcher function
const fetchApplications = async (
  publisherId: string,
): Promise<Application[]> => {
  const response = await apiClient.get(
    `/v2/publisher/dashboard/${publisherId}/applications`,
  );
  return response.data.applications || [];
};

// Custom Hook
const useApplications = (publisherId: string) => {
  return useQuery({
    queryKey: ['applications', publisherId],
    queryFn: () => fetchApplications(publisherId),
    staleTime: 5 * 60 * 1000,
    retry: 3,
    refetchOnWindowFocus: false,
  });
};

export default useApplications;
